(function (_$) {
    $ = _$;
})(jQuery);
console.log("init app");
umpApp.init();
// if (navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i)) {

// }
window.addEventListener("load", function () {
    setTimeout(function () {
        window.scrollTo(0, 1);
    }, 1000);
});